import styled from "@emotion/native";
import { Animated, ViewStyle, Platform, Dimensions } from "react-native";
import _DrawerButton from "../../components/DrawerButton";
import Text from "../../components/Text";
import Button from "../../components/Button";
import * as drawer from "../../utils/drawer";

const { height } = Dimensions.get("window");

export const Container = styled.View(
    {
        flex: 1,
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);

export const Background = styled.Image({
    position: "absolute",
    width: "100%",
    height: "100%",
    resizeMode: "cover",
});

export const Scroll = styled.ScrollView(
    {
        marginTop:
            drawer.BUTTON_TOP + drawer.BUTTON_HEIGHT + drawer.MARGIN_BOTTOM,
        overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
    },
    ({ theme }: any) => {
        let style: ViewStyle = {};

        if (theme.verticalScale < 1) {
            const buttonTop = drawer.BUTTON_TOP * theme.verticalScale;
            const buttonHeight = drawer.BUTTON_HEIGHT * theme.verticalScale;
            const marginBottom = drawer.MARGIN_BOTTOM * theme.verticalScale;
            const marginTop = buttonTop + buttonHeight + marginBottom;

            style = {
                marginTop,
                height: height - marginTop,
            };
        }

        return style;
    },
);

Scroll.defaultProps = {
    contentContainerStyle: { flexGrow: 1 },
};

export const Spacer = styled(Animated.View)({});

export const Content = styled(Animated.View)({
    flex: 1, // prevents accidental clipping of the view
});

export const Intro = styled(Text)({
    marginTop: 14,
    paddingHorizontal: 13,
    marginBottom: 40,
});

export const HeroText = styled(Text)(
    {
        marginTop: 4,
        marginLeft: 6,
        marginRight: 6,
    },
    ({ theme }: any) => {
        return { color: theme.color.text };
    },
);

export const SafetyStrategies = styled.View({
    height: 195,
    marginBottom: 34,
});

export const SafetyStrategiesScroll = styled.ScrollView({
    paddingHorizontal: 13,
});

export const SafetyStrategiesHeadline = styled(Text)({
    paddingLeft: 13,
    marginBottom: 30,
});

export const TakenAllQuizzes = styled.View({
    marginBottom: 40,
});

export const TakenAllQuizzesIntro = styled(Text)({
    marginTop: 14,
    paddingHorizontal: 13,
    marginBottom: 40,
});

export const ReviewQuizzesButton = styled(Button)({});

export const QuizQueueContainer = styled.View({ flex: 1 });
